import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import './global.scss'
import GlobalFooter from './GlobalFooter';
function CanadaFailed() {
    const [searchParams] = useSearchParams();
    const [isLoading,setIsLoading] = useState(false)
    const record  = localStorage.getItem('flings')
    const redirect  = localStorage.getItem('redirect')
    const navigate = useNavigate()

   

    const handleClick =()=>{
        navigate(`/pages/canada`)
    }
    const handleClose = ()=>{
        navigate('/pages/global-payment')
    }
  return (
    <div className='global_layout'>
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
        } */}
           
    
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt=''/> */}
                <img src='/images/global/close.svg' alt='' onClick={handleClose} style={{marginLeft:"auto"}}/>
            </div> 

            <div className='global_content'>
                <img style={{width:"60px",height:"60px"}} src='/images/global/sickFace.gif' alt='' />
                <p className='glob_title'>Payment Failed</p>
                <p className='glob_desc'>Your transaction was not successful.</p>
                
                {/* <button className='btn' style={{marginTop:"18px",background:"#228985",borderRadius:"10000px"}} onClick={handleClick}>Try again</button> */}

            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default CanadaFailed